import { Color } from 'csstype';

export enum LoginState{
	notConnected,
	inLobby,
	inGame,
	gameFinished,
	disconnected,

}
export enum GameState {
    Initilising = -1,
	Tutorial = 3,
	Menu = 1,
	Level = 2,
	LevelEditor = 3,
	Loading = -2,
}
export interface PlayerData {
	name: string,
	icon: number,
	color: Color,
	index: number,
}
export interface GameServerData {
    connectionUrl: string;
    version: number;
    isDev:boolean;
    id:number;
}
export interface ActiveGame {code:string, startTime:number, playerCount: number, status?:GameState, level?: string}

export interface GameStatus {
    id: number,
    connectionString: string,
    version: number,
    startTime: number,
    hasKillSignal: boolean,
    games:ActiveGame[]
}

export interface VerifiedGameStatus extends Partial<GameStatus> {
    status: string;
}

export interface ServerStatus {
    gamesPlayed: number,
	currentId: number,
	version: number,
    startTime: number,
    gameServers: VerifiedGameStatus[]
}


// WEBPACK FOOTER //
// ./src/Models/ApplicationInterfaces.ts